const DANA_URL = `${process.env.API_V4_HOST}/_exclusive/e-wallets/dana`;

export const retrieveDanaProfile = $axios => $axios.$get(`${DANA_URL}/profile`);
